import Image from "next/image"

import _ from 'lodash'

import { Header, HeaderShim } from "../fuselage/global/header/header"
import { IntroHero } from "../fuselage/blocks/intro-hero/intro-hero"
import { IntroUnit, IntroUnitTitle, IntroUnitBody } from '../fuselage/blocks/intro-unit/intro-unit'
import { ArrowButton } from "../fuselage/components/arrow-button/arrow-button"
import { Floaters, Floater } from "../fuselage/blocks/floater/floater"
import { Button } from "../fuselage/components/button/button"

import { GetBizzaboPartersByLevel } from '../lib/bizzabo-partner-levels'
import { ColorGlow } from "../fuselage/theme/color-glow/color-glow"

export default function TravelAndAccommodation ({ partnerData }) {

    return (
        <>

            <HeaderShim />

            <IntroHero 
                hero={{ src: '/assets/img/accommodation.jpg', width: 1920, height: 840 }} 
                heroMobile={{ src: '/assets/img/accommodation-mobile.jpg', width: 800, height: 800 }} 
            />

            <IntroUnit overlapHero>
                <IntroUnitTitle>
                    <div className="formatted">
                        <p className="fs-0 fw-600 lh-1">Travel &amp; Hotel </p>
                        <div className="mt-sm">
                            <p>
                                <ArrowButton href={`https://www.hyatt.com/en-US/group-booking/ATHGH/G-GTHY`} large inverse target={`_blank`}>
                                    Book room at Grand Hyatt Athens
                                </ArrowButton>
                            </p>
                        </div>
                    </div>
                </IntroUnitTitle>

                <IntroUnitBody>
                    <div className="fw-300">
                        <p className="fs-6">Greece is one of the many markets in Southeast Europe with exciting opportunities to invest and grow the hospitality sector. Maximise your time at IDEEA further by exploring the city of Athens and wider Greece to see the market potential first-hand.</p>
                        <p className="fs-6">We highly recommend staying at the venue for a productive and engaging two days at IDEEA. Don&apos;t miss out on the evening reception or skip crucial morning sessions by staying further away. Purchase your IDEEA pass today and get access to our exclusive rate for rooms at the Grand Hyatt Athens.</p>
                    </div>
                </IntroUnitBody>
            </IntroUnit>




            <Floaters>
				<Floater hero={`/assets/img/accommodation-floater-02.jpg`}>
                    <div className="formatted">
                        <p className="fs-2 fw-600 lh-2">Travel to Greece</p>
                        <p className="fs-6">From May 2022, Greece has eliminated the need to show proof of vaccination or COVID recovery on entering the country, so everyone with valid travel documents should be eligible to visit. Evidence of vaccination/recovery is no longer needed to enter specific indoor spaces like museums, sporting venues or theatres. Please get in touch with your nearest embassy for the most up-to-date information on any necessary visa requirements or protocols.</p>
                    </div>
                    <p className="mt-sm">
                        <ArrowButton href='https://travel.gov.gr/' large target={`blank`}>
                            View Protocol for Arrivals in Greece
                        </ArrowButton>
                    </p>
				</Floater>
				
                <Floater hero={`/assets/img/accommodation-floater-01.jpg`}>
                    <div className="formatted">
                        <p className="fs-2 fw-600 lh-2">Stay at Grand Hyatt Athens</p>
                        <p className="fs-6">IDEEA takes place on 26-27 September at the Grand Hyatt Athens in Greece. The property opened in August 2018 and boasts a brand-new spa, atrium pool &amp; bar and a rooftop with stunning views over the Acropolis.</p>
                        <p className="fs-6">Book your room today at the exclusive rate reserved for those participating at IDEEA.</p>
                    </div>
                    <p className="mt-sm">
                        <ArrowButton href={`https://www.hyatt.com/en-US/group-booking/ATHGH/G-GTHY`} large target={`_blank`}>
                            Book room at Grand Hyatt Athens
                        </ArrowButton>
                    </p>
				</Floater>
            </Floaters>




            {/* partners */}

			<section className="block bg-default">
				<div className="container center-desktop formattet">
					<p className="fs-0 fw-800 caps c-black">IDEEA 2022 <br/>Sponsors &amp; Partners</p>
					<p className="fs-5 maxw-50 mx-auto mt-sm">Thank you to our sponsors and partners whose support has been integral in gathering the hospitality investment community across Europe together to refocus on a new future.</p>
				</div>

				<div className="container">
					{ GetBizzaboPartersByLevel( 1, partnerData ) }
					{ GetBizzaboPartersByLevel( 2, partnerData ) }
					{ GetBizzaboPartersByLevel( 8, partnerData ) }
				</div>
			</section>







        </>
    )
}



export async function getStaticProps({ params, preview, previewData }) {
	
	const partners = await fetch(`https://api.bizzabo.com/api/partners?eventId=${process.env.BIZZABO_EVENT_ID}`, {
		"method": "GET",
		"headers": {
			"Content-Type": "application/json",
			"Authorization": "Bearer 67f61f9e-e897-4536-914e-3f47286650f9"
		}
	})
	const partnerData = await partners.json()

	
    return { 
		props: { 
			partnerData: partnerData.content
		}
	}
}